import {createAction, props} from '@ngrx/store';
import {
  getActionDescription,
  getApiActionsWithPayload,
} from '@binotel-frontend/bnt-common-components';
import {
  EPhoneUpdateSteps,
  IUpdatePayload,
  IUpdateResult,
} from '@entities/settings';

const desc = getActionDescription('Settings');

export namespace SettingsActions {
  export const updateUsersPhone = getApiActionsWithPayload(
    desc('Update users phone'),
    props<{payload: Partial<IUpdatePayload>}>(),
    props<{payload: IUpdateResult}>()
  );
  export const setCurrentPhoneStep = createAction(
    desc('Set Current Phone Step'),
    props<{to: EPhoneUpdateSteps}>()
  );
}
